import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MyCourseComponent } from './my-course/my-course.component';
import { StudentProfileComponent } from './student-profile/student-profile.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { HomeComponent } from './home/home.component';
import { StudentLearningComponent } from './student-learning/student-learning.component';
import { StudentEnrollComponent } from './student-enroll/student-enroll.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import { NotificationComponent } from './notification/notification.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FestivalDetailsComponent } from './festival-details/festival-details.component';
import { MyReferralsComponent } from './my-referrals/my-referrals.component';
import { FAQComponent } from './faq/faq.component';
import { CoursesComponent } from './courses/courses.component';
import { CourseDetailsComponent } from './course-details/course-details.component';
import { ChapterDetailsComponent } from './chapter-details/chapter-details.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { ExamComponent } from './exam/exam.component';
import { MyCartComponent } from './my-cart/my-cart.component';
import { MyCoursedetailsComponent } from './my-coursedetails/my-coursedetails.component';
import { MasterCourseComponent } from './master-course/master-course.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { TrainerProfileComponent } from './trainer-profile/trainer-profile.component';


const routes: Routes = [
  {
    path: '',
    component: MasterCourseComponent,
    data: {
      
      icon: 'icon-home',
      caption: 'Panel',
      status: true,
      // title: 'Vedic Tree School',
      // descrption: 'Vedic Tree School',
      // ogTitle: 'Vedic Tree School',
    }
  },
  {
    path: 'header',
    component: HeaderComponent,
    data: {
      title: 'header',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'master-course',
    component: MasterCourseComponent,
    data: {
      title: 'header',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'about',
    component: AboutComponent,
    data: {
      title: 'header',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'contact',
    component: ContactComponent,
    data: {
      title: 'header',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'footer',
    component: FooterComponent,
    data: {
      title: 'footer',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'my-course',
    component: MyCourseComponent,
    data: {
      title: 'my-course',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
 
  {
    path: 'student-profile',
    component: StudentProfileComponent,
    data: {
      title: 'student-profile',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'login',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
   {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'register',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  // {
  //   path: 'home',
  //   component: HomeComponent,
  //   data: {
  //     title: 'home',
  //     icon: 'icon-home',
  //     caption: 'Panel',
  //     status: true
  //   }
  // },
  {
    path: 'student-learning',
    component: StudentLearningComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'student-learning/:id',
    component: StudentLearningComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'student-enroll',
    component: StudentEnrollComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'student-dashboard',
    component: StudentDashboardComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'student-profile',
    component: StudentProfileComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'my-course',
    component: MyCourseComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'my-transactions',
    component: TransactionsComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'my-cart',
    component: MyCartComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'payment-confirmation',
    component: PaymentConfirmationComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'payment-confirmation/:string',
    component: PaymentConfirmationComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'exam',
    component: ExamComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
    {
    path: 'notification',
    component: NotificationComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'festival-details',
    component: FestivalDetailsComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'my-referrals',
    component: MyReferralsComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'FAQ',
    component: FAQComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'courses',
    component: CoursesComponent,
    data: {
      title: 'Courses',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'course-details',
    component: CourseDetailsComponent,
    data: {
      title: 'Course details',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'mycourse-details',
    component: MyCoursedetailsComponent,
    data: {
      title: 'Course details',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'chapter-details',
    component: ChapterDetailsComponent,
    data: {
      title: 'Course details',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'my-profile',
    component: MyProfileComponent,
    data: {
      title: 'Profile details',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'search-results',
    component: SearchResultsComponent,
    data: {
      title: 'Search results',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'assessment',
    component: AssessmentComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'terms-condition',
    component: TermsConditionsComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  },
  {
    path: 'trainer-profile',
    component: TrainerProfileComponent,
    data: {
      title: 'home',
      icon: 'icon-home',
      caption: 'Panel',
      status: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true,scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
  
})
export class AppRoutingModule { }
